import { $ as e, G as t, J as n, K as r, Y as i, Z as a, d as o, dt as s, ft as c, l, m as u, n as d, p as f, q as p, s as m, t as h, u as g, ut as _ } from "./chunk-client-WKUGyy6G.js";
import { t as v } from "./chunk-Configure-ByHz2hue.js";
import { a as y, i as b, n as x, r as ee, t as S } from "./chunk-routing-Hc8Taf1E.js";
import { a as C, i as w, n as T, o as E, r as D, t as O } from "./chunk-useDebouncedQueryHook-BhaJon0h.js";
//#region src/lib/search/PagesResults.tsx
function k() {
	return /* @__PURE__ */ m("div", {
		className: "mx-auto max-w-2xl p-8 text-center",
		children: [
			/* @__PURE__ */ m("h3", {
				className: "p mb-8",
				"aria-live": "assertive",
				children: window.generalStrings.search.noResultsFoundHeading
			}),
			/* @__PURE__ */ m("h4", {
				className: "h4 mb-4",
				children: window.generalStrings.search.needAssistance
			}),
			/* @__PURE__ */ m("div", {
				className: "rte mb-4 font-light",
				children: /* @__PURE__ */ m("p", { children: window.generalStrings.search.pagesEmptyHelp })
			})
		]
	});
}
function A({ pages: e }) {
	let { status: t } = o();
	return e.length === 0 ? t === "idle" ? /* @__PURE__ */ m(k, {}) : null : /* @__PURE__ */ m("ul", {
		className: "px-safe-or-2 mx-auto flex max-w-3xl flex-col gap-6 py-8",
		children: e.map((e) => /* @__PURE__ */ m("li", {
			className: "border-b-brand-light border-b pb-6 last:border-b-0",
			children: /* @__PURE__ */ m("a", {
				href: e.url,
				className: "group/page block",
				children: [
					/* @__PURE__ */ m("h3", {
						className: "h6 mb-3",
						children: e.title.split(" | ")[0]
					}),
					e.description && /* @__PURE__ */ m("p", {
						className: "p-mini text-brand-darkest font-light",
						children: e.description
					}),
					/* @__PURE__ */ m("span", {
						className: "p-mini text-brand-darkest group-hover/page:text-brand-dark mt-2 block font-light underline transition-colors",
						"aria-hidden": "true",
						children: window.generalStrings.search.readMoreLink
					})
				]
			})
		}, e.objectID))
	});
}
//#endregion
//#region src/lib/search/QuickResults.tsx
function j({ hit: e }) {
	let t = l(e.url);
	return /* @__PURE__ */ m("a", {
		href: e.url,
		className: "btn btn--pill",
		children: [t == "store" ? /* @__PURE__ */ m("span", {
			className: "inline-flex items-center rounded-xs text-xs uppercase",
			children: [/* @__PURE__ */ m("span", {
				className: "sr-only",
				children: [t, ": "]
			}), /* @__PURE__ */ m("svg-icon", {
				src: "icon-pin",
				className: "size-4 fill-current"
			})]
		}) : "", /* @__PURE__ */ m("span", {
			className: "line-clamp-1",
			children: e.title.split(" | ")[0].split(", ")[0]
		})]
	});
}
var M = ({ types: e }) => /* @__PURE__ */ m("div", {
	className: "col-span-full mb-2 has-[.ais-Hits--empty]:hidden",
	children: /* @__PURE__ */ m(E, {
		indexName: "shopify_pages_and_metaobjects",
		children: [/* @__PURE__ */ m(D, {
			hitComponent: j,
			classNames: {
				list: "relative mb-2 md:mb-4 px-safe-or-2 pb-2 pt-1 flex lg:flex-wrap overflow-auto lg:overflow-hidden items-center lg:justify-center gap-2 md:gap-4 w-full scrollbar-none overscroll-contain lg:overscroll-auto lg:max-w-4xl lg:mx-auto",
				item: "shrink-0"
			},
			transformItems: (t) => e ? t.filter((t) => e.includes(l(t.url))) : t
		}), /* @__PURE__ */ m(v, { hitsPerPage: 6 })]
	})
}), N = null;
function P() {
	if (N) return N;
	let e = document.getElementById("storeInfoArray");
	if (!e?.textContent) return N = [], N;
	try {
		N = JSON.parse(e.textContent);
	} catch (e) {
		console.error("Failed to parse store data", e), N = [];
	}
	return N;
}
function F(e, t) {
	let n = t.trim().toLowerCase();
	return n ? e.filter((e) => [e.title, e.store_address].filter((e) => !!e).some((e) => e.toLowerCase().includes(n))) : e;
}
function I(e) {
	if (!e) return "";
	let t = document.createElement("div");
	return t.innerHTML = e, t.querySelectorAll("br").forEach((e) => e.replaceWith("\n")), t.textContent ?? "";
}
function L(e) {
	if (!e) return "";
	let t = e.replace(/\D/g, ""), n = t.length === 11 && t.startsWith("1") ? t.slice(1) : t;
	return n.length === 10 ? `(${n.slice(0, 3)}) ${n.slice(3, 6)}-${n.slice(6)}` : e;
}
//#endregion
//#region src/lib/search/StoreCard.tsx
function R({ store: e }) {
	return /* @__PURE__ */ m("li", {
		className: "flex h-full flex-col justify-stretch overflow-hidden rounded-sm bg-white",
		children: [/* @__PURE__ */ m("a", {
			href: e.store_page,
			className: "bg-brand-light block aspect-video",
			children: [e.store_img ? /* @__PURE__ */ m("img", {
				src: e.store_img,
				alt: "",
				loading: "lazy",
				className: "aspect-video w-full object-cover"
			}) : /* @__PURE__ */ m("div", { className: "bg-brand-light aspect-video" }), /* @__PURE__ */ m("span", {
				className: "sr-only",
				children: e.title
			})]
		}), /* @__PURE__ */ m("div", {
			className: "grid grid-cols-2 gap-y-6 p-4",
			children: [/* @__PURE__ */ m("div", {
				className: "col-span-full flex flex-col gap-2.5",
				children: /* @__PURE__ */ m("h3", {
					className: "h5 text-left",
					children: [e.store_fascia && /* @__PURE__ */ m("span", {
						className: "utility block uppercase",
						children: e.store_fascia
					}), /* @__PURE__ */ m("a", {
						href: e.store_page,
						className: "text-left text-balance",
						children: e.title
					})]
				})
			}), /* @__PURE__ */ m("div", {
				className: "col-span-full grid grid-cols-2 gap-x-5 gap-y-3.5",
				children: [
					/* @__PURE__ */ m("div", {
						className: "flex flex-col gap-3",
						children: [/* @__PURE__ */ m("h4", {
							className: "utility-mini uppercase",
							children: window.generalStrings.search.storeContactLabel
						}), /* @__PURE__ */ m("div", {
							className: "text-brand-dark text-[0.815rem] leading-[1.3] font-light whitespace-pre-line",
							children: I(e.store_address)
						})]
					}),
					/* @__PURE__ */ m("div", {
						className: "col-span-full grid grid-cols-2 gap-x-3 text-xs",
						children: [e.store_number && /* @__PURE__ */ m("a", {
							className: "hover:text-brand-dark underline",
							href: `tel:${e.store_number}`,
							children: L(e.store_number)
						}), e.store_directions && /* @__PURE__ */ m("a", {
							className: "hover:text-brand-dark underline",
							href: e.store_directions,
							target: "_blank",
							rel: "noreferrer",
							children: window.generalStrings.search.storeGetDirections
						})]
					}),
					/* @__PURE__ */ m("a", {
						className: "btn bg-brand-lighter hover:bg-brand-light col-span-full mt-2 w-full",
						href: e.store_page,
						children: /* @__PURE__ */ m("span", { children: window.generalStrings.viewDetails })
					})
				]
			})]
		})]
	});
}
//#endregion
//#region src/lib/search/StoresResults.tsx
function z() {
	return /* @__PURE__ */ m("div", {
		className: "mx-auto max-w-2xl p-8 text-center",
		children: [
			/* @__PURE__ */ m("h3", {
				className: "p mb-8",
				"aria-live": "assertive",
				children: window.generalStrings.search.noResultsFoundHeading
			}),
			/* @__PURE__ */ m("h4", {
				className: "h4 mb-4",
				children: window.generalStrings.search.findAStore
			}),
			/* @__PURE__ */ m("div", {
				className: "rte mb-4 font-light",
				children: /* @__PURE__ */ m("p", { dangerouslySetInnerHTML: { __html: window.generalStrings.search.storesEmptyHelpHtml } })
			})
		]
	});
}
function B({ stores: e }) {
	return e.length === 0 ? /* @__PURE__ */ m(z, {}) : /* @__PURE__ */ m("ul", {
		className: "px-safe-or-2 grid grid-cols-1 gap-5 pt-4 pb-8 md:grid-cols-2 lg:grid-cols-3",
		children: e.map((e) => /* @__PURE__ */ m(R, { store: e }, e.id))
	});
}
t(), a();
function V(e) {
	return e === "products" || e === "pages" || e === "stores";
}
var { appId: te, searchKey: H, indexName: U } = c, W = d(te, H), G = u({ push: x }), K = "products", q = G.read();
V(q?.tab) && (K = q.tab);
var J = /* @__PURE__ */ new Set();
function Y(e) {
	K = e, J.forEach((t) => t(e));
}
function X() {
	let [e, t] = i(K);
	return r(() => (J.add(t), () => {
		J.delete(t);
	}), []), [e, (e) => {
		e !== K && (Y(e), G.write({
			...G.read(),
			tab: e
		}));
	}];
}
var Z = {
	router: G,
	stateMapping: {
		stateToRoute(e) {
			return {
				q: e[U]?.query,
				...S(e[s]),
				tab: K
			};
		},
		routeToState(e) {
			return V(e.tab) && Y(e.tab), {
				[U]: { query: e.q },
				[s]: ee(e)
			};
		}
	}
}, Q = [
	{
		id: "products",
		label: window.generalStrings.search.tabProducts
	},
	{
		id: "pages",
		label: window.generalStrings.search.tabPages
	},
	{
		id: "stores",
		label: window.generalStrings.search.tabStores
	}
];
function ne({ activeTab: e, onSelect: t, counts: n }) {
	return /* @__PURE__ */ m("div", {
		role: "tablist",
		className: "border-b-brand-light px-safe-or-2 flex justify-center gap-4 border-b",
		children: Q.map((r) => /* @__PURE__ */ m("button", {
			type: "button",
			role: "tab",
			"aria-selected": e === r.id,
			onClick: () => t(r.id),
			className: `p -mb-px border-b-2 px-1 pb-3 ${e === r.id ? "border-brand-accent text-brand-darkest" : "text-brand-dark border-transparent"}`,
			children: [
				r.label,
				" (",
				n[r.id],
				")"
			]
		}, r.id))
	});
}
function re() {
	let { status: e } = o(), t = p(!1), n = p(!1);
	return r(() => {
		if (e === "loading" || e === "stalled") {
			t.current = !0;
			return;
		}
		if (e !== "idle" || !t.current || n.current) return;
		n.current = !0, document.getElementById("search-page-skeleton")?.remove(), document.getElementById("search-page")?.classList.remove("hidden");
		let r = document.querySelector("[data-search-page-input]");
		r && (r.focus(), r.setSelectionRange(0, r.value.length));
	}, [e]), null;
}
function ie({ onChange: e }) {
	let { nbHits: t } = y();
	return r(() => {
		e(t);
	}, [t, e]), null;
}
function ae({ onChange: e }) {
	let { items: t } = C();
	return r(() => {
		e(t.filter((e) => l(e.url) !== "store"));
	}, [t, e]), null;
}
function oe() {
	let [t, r] = X(), { query: a } = w(), [o, c] = i(0), [l, u] = i([]), d = n(() => P(), []), f = n(() => F(d, a), [d, a]);
	return /* @__PURE__ */ m(e, { children: [
		/* @__PURE__ */ m(ne, {
			activeTab: t,
			onSelect: r,
			counts: {
				products: o,
				pages: l.length,
				stores: f.length
			}
		}),
		/* @__PURE__ */ m(E, {
			indexName: "shopify_products",
			indexId: s,
			children: [/* @__PURE__ */ m(ie, { onChange: c }), /* @__PURE__ */ m("div", {
				className: t === "products" ? void 0 : "hidden",
				children: [/* @__PURE__ */ m(v, { hitsPerPage: 12 }), /* @__PURE__ */ m(b, {})]
			})]
		}),
		/* @__PURE__ */ m(E, {
			indexName: "shopify_pages_and_metaobjects",
			indexId: _,
			children: [
				/* @__PURE__ */ m(v, { hitsPerPage: 1e3 }),
				/* @__PURE__ */ m(ae, { onChange: u }),
				/* @__PURE__ */ m("div", {
					className: t === "pages" ? "bg-brand-lightest" : "hidden",
					children: /* @__PURE__ */ m(A, { pages: l })
				})
			]
		}),
		t === "stores" && /* @__PURE__ */ m("div", {
			className: "bg-brand-lightest",
			children: /* @__PURE__ */ m(B, { stores: f })
		})
	] });
}
var se = {
	id: "SearchQueryPage",
	"data-search-page-input": ""
};
function ce() {
	let e = O();
	return /* @__PURE__ */ m(f, {
		searchClient: W,
		indexName: U,
		routing: Z,
		children: [
			/* @__PURE__ */ m(g, {}),
			/* @__PURE__ */ m(re, {}),
			/* @__PURE__ */ m(T, {
				queryHook: e,
				className: "col-span-full",
				classNames: {
					root: "",
					form: "mx-auto w-full lg:max-w-2xl px-safe-or-2 mb-4 relative flex items-center",
					input: "no-clear-button bg-brand-lighter outline-none focus-visible:outline-brand-focus transition-colors w-full placeholder-brand-dark rounded-full h6 leading-none py-4 pr-14 pl-[50px]",
					reset: "absolute right-6 focus-visible:outline-brand-focus underline",
					submit: "absolute left-6",
					loadingIndicator: "absolute right-6"
				},
				submitIconComponent: ({ classNames: e }) => /* @__PURE__ */ m("span", {
					className: e.submitIcon,
					children: /* @__PURE__ */ m("svg-icon", { src: "icon-search" })
				}),
				resetIconComponent: ({ classNames: e }) => /* @__PURE__ */ m("span", {
					className: e.resetIcon,
					children: window.generalStrings.search.clear
				}),
				placeholder: window.generalStrings.search.pagePlaceholder,
				inputProps: se
			}),
			/* @__PURE__ */ m(M, {}),
			/* @__PURE__ */ m(oe, {})
		]
	});
}
var $ = document.getElementById("search-page");
$ && h.createRoot($).render(/* @__PURE__ */ m(ce, {}));
//#endregion
